import _cloneDeep from 'lodash/cloneDeep'

import {
  GET_LEADER_REQUESTED,
  GET_LEADER_SUCCESS,
  GET_DEPARTMENTS_REQUESTED,
  GET_DEPARTMENTS_SUCCESS,
  CLEAR_ERROR_SUCCESS,
  OPEN_MODAL_SUCCESS,
  REQUEST_PUT_SUCCESS,
  PAGE_BRANCH_FAILED,
  GET_CASHBOX_REQUESTED,
  GET_CASHBOX_SUCCESS,
  GET_CASHBOX_FAILED,
  ADD_CASHBOX_REQUESTED,
  ADD_CASHBOX_SUCCESS,
  ADD_CASHBOX_FAILED,
  GET_EMPLOYEES_REQUESTED,
  GET_DEPARTMENTLEADER_REQUESTED,
  GET_DEPARTMENTLEADER_SUCCESS,
  GET_DEPARTMENTLEADER_FAILED,
  GET_CHIEFACCOUNTANT_REQUESTED,
  GET_CHIEFACCOUNTANT_SUCCESS,
  GET_CHIEFACCOUNTANT_FAILED,
  GET_ACCOUNTANT_REQUESTED,
  GET_ACCOUNTANT_SUCCESS,
  GET_ACCOUNTANT_FAILED,
  GET_SENIORCOMMODITYEXPERT_REQUESTED,
  GET_SENIORCOMMODITYEXPERT_SUCCESS,
  GET_SENIORCOMMODITYEXPERT_FAILED,
  GET_GOODSSPECIALIST_REQUESTED,
  GET_GOODSSPECIALIST_SUCCESS,
  GET_GOODSSPECIALIST_FAILED,
  GET_EMPLOYEE_REQUESTED,
  GET_EMPLOYEE_SUCCESS,
  GET_EMPLOYEE_FAILED,
  GET_REASONS_REQUESTED,
  GET_REASONS_SUCCESS,
  GET_REASONS_FAILED,
  HANDBOOK_RESET,
  CASHBOX_RESET,
  ADD_BRANCH_REQUESTED,
  ADD_BRANCH_SUCCESS,
  GET_BRANCHES_REQUESTED,
  GET_BRANCHES_SUCCESS,
  CHANGE_BRANCH_REQUESTED,
  CHANGE_BRANCH_SUCCESS,
  DELETE_BRANCH_REQUESTED,
  DELETE_BRANCH_SUCCESS,
  BRANCH_FAILED,
  CHANGE_AD_IMAGE_REQUESTED,
  CHANGE_AD_IMAGE_SUCCESS,
  GET_AD_IMAGE_REQUESTED,
  GET_AD_IMAGE_SUCCESS,
  DELETE_AD_IMAGE_REQUESTED,
  DELETE_AD_IMAGE_SUCCESS,
  AD_IMAGE_FAILED,
  GET_FULL_NAME_SUCCESS,
  GET_DEAL_NUMBER_SUCCESS,
  GET_DEPARTMENTS_TAB_SUCCESS, RESET_ALL_OPTIONS, RESET_HANDBOOK_ERROR,
} from '../actions/actionTypes'

const initialState = {
  data: {},
  leader: [],
  departments: [],
  branches: [],
  clients: [],
  dealsNumber: [],
  loading: false,
  commonError: false,
  total: 0,
  isLoading: false,
  isPut: false,
  isModal: false,
  errorMessage: false,
  cashbox: {},
  addDepartment: false,
  addDepartmentLoading: false,
  addDepartmentError: '',
  departmentLeader: [],
  chiefAccountant: [],
  accountant: [],
  seniorCommodityExpert: [],
  goodsSpecialist: [],
  employeesError: '',
  users: [],
  usersLoading: false,
  reasons: [],
  reasonsLoading: false,
  reasonsError: '',
  totalPages: 1,
  advertImage: '',
  adImageName: '',
  branchId: null
}

const branchReducer = (state = _cloneDeep(initialState), action) => {
  switch (action.type) {
    case RESET_ALL_OPTIONS:
      return {
        ...state,
        departments: [],
        clients: [],
        dealsNumber: [],
      }
    case GET_DEPARTMENTS_TAB_SUCCESS:
      return {
        ...state,
        departments: action.payload.data.cashBoxes.map(el => ({value: el.id, label: el.name, action: 'department'})),
        loading: false,
      }
    case GET_DEAL_NUMBER_SUCCESS:
      return {
        ...state,
        dealsNumber: action.payload.data.deals.map(el => ({
          value: el.id,
          label: el.dealNumber,
          transferId: el.transferId,
          dealStatus: el.dealStatus,
          action: 'dealNumber',
          gohranSaleId: el.gohranSaleId,
        })),
        loading: false,
        commonError: ''
      }
    case GET_FULL_NAME_SUCCESS:
      return {
        ...state,
        clients: action.payload.data.clients.map(el => ({value: el.id, label: el.fullName, action: 'fullName'})),
        loading: false
      }
    case GET_LEADER_REQUESTED:
      return {
        ...state,
        loading: true,
        commonError: false,
        errorMessage: false
      }
    case GET_LEADER_SUCCESS:
      return {
        ...state,
        leader: action.payload.map(u => ({ value: u.id, label: u.fullName })),
        loading: false,
      }
    case GET_DEPARTMENTS_REQUESTED:
      return {
        ...state,
        loading: true,
        commonError: false,
        errorMessage: false
      }
    case GET_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        departments: action.payload,
        loading: false,
      }
    case CLEAR_ERROR_SUCCESS:
      return {
        ...state,
        advertImage: '',
        adImageName: '',
        commonError: false,
        isModal: false,
        isPut: false,
        isLoading: false,
        errorMessage: false
      }

    case OPEN_MODAL_SUCCESS:
      return {
        ...state,
        isModal: true
      }
    case REQUEST_PUT_SUCCESS:
      return {
        ...state,
        isPut: true
      }
    case PAGE_BRANCH_FAILED:
      return {
        ...state,
        loading: false,
        commonError: action.payload
      }
    case GET_CASHBOX_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case GET_CASHBOX_SUCCESS:
      return {
        ...state,
        loading: false,
        cashbox: action.payload
      }
    case GET_CASHBOX_FAILED:
      return {
        ...state,
        loading: false,
        commonError: action.payload
      }
    case CASHBOX_RESET:
      return {
        ...state,
        cashbox: {}
      }
    case ADD_CASHBOX_REQUESTED:
      return {
        ...state,
        addDepartmentLoading: true,
      }
    case ADD_CASHBOX_SUCCESS:
      return {
        ...state,
        addDepartmentLoading: false,
        addDepartment: true
      }
    case ADD_CASHBOX_FAILED:
      return {
        ...state,
        addDepartmentLoading: false,
        addDepartmentError: action.payload
      }
    case GET_DEPARTMENTLEADER_REQUESTED:
      return state
    case GET_DEPARTMENTLEADER_SUCCESS:
      return {
        ...state,
        departmentLeader: action.payload.map(u => ({ value: u.id, label: u.fullName }))
      }
    case GET_DEPARTMENTLEADER_FAILED:
      return {
        ...state,
        employeesError: action.payload
      }
    case GET_CHIEFACCOUNTANT_REQUESTED:
      return state
    case GET_CHIEFACCOUNTANT_SUCCESS:
      return {
        ...state,
        chiefAccountant: action.payload.map(u => ({ value: u.id, label: u.fullName }))
      }
    case GET_CHIEFACCOUNTANT_FAILED:
      return {
        ...state,
        employeesError: action.payload
      }
    case GET_ACCOUNTANT_REQUESTED:
      return state
    case GET_ACCOUNTANT_SUCCESS:
      return {
        ...state,
        accountant: action.payload.map(u => ({ value: u.id, label: u.fullName }))
      }
    case GET_ACCOUNTANT_FAILED:
      return {
        ...state,
        employeesError: action.payload
      }
    case GET_SENIORCOMMODITYEXPERT_REQUESTED:
      return state
    case GET_SENIORCOMMODITYEXPERT_SUCCESS:
      return {
        ...state,
        seniorCommodityExpert: action.payload.map(u => ({ value: u.id, label: u.fullName }))
      }
    case GET_SENIORCOMMODITYEXPERT_FAILED:
      return {
        ...state,
        employeesError: action.payload
      }
    case GET_GOODSSPECIALIST_REQUESTED:
      return state
    case GET_GOODSSPECIALIST_SUCCESS:
      return {
        ...state,
        goodsSpecialist: action.payload.map(u => ({ value: u.id, label: u.fullName }))
      }
    case GET_GOODSSPECIALIST_FAILED:
      return {
        ...state,
        employeesError: action.payload
      }
    case GET_EMPLOYEES_REQUESTED:
      return state
    case GET_EMPLOYEE_REQUESTED:
      return {
        ...state,
        usersLoading: true
      }
    case GET_EMPLOYEE_SUCCESS:
      return {
        ...state,
        users: action.payload,
        usersLoading: false
      }
    case GET_EMPLOYEE_FAILED:
      return {
        ...state,
        usersLoading: false,
        employeesError: action.payload
      }
    case GET_REASONS_REQUESTED:
      return {
        ...state,
        reasonsLoading: true
      }
    case GET_REASONS_SUCCESS:
      return {
        ...state,
        reasons: action.payload.map((v) => ({
          value: parseInt(v.code),
          label: v.name,
        })),
        reasonsLoading: false
      }
    case GET_REASONS_FAILED:
      return {
        ...state,
        usersLoading: false,
        reasonsError: action.payload
      }
    case HANDBOOK_RESET:
      return _cloneDeep(initialState)
    case ADD_BRANCH_REQUESTED:
      return {
        ...state,
        loading: true,
        commonError: false,
        errorMessage: false
      }
    case ADD_BRANCH_SUCCESS:
      return {
        ...state,
        branches: action.payload.branches,
        loading: false,
        isModal: false,
        totalPages: action.payload.totalPages,
      }
    case GET_BRANCHES_REQUESTED:
      return {
        ...state,
        isLoading: true,
        commonError: false,
        errorMessage: false
      }
    case GET_BRANCHES_SUCCESS:
      return {
        ...state,
        branches: action.payload.branches,
        total: action.payload.totalElements,
        isLoading: false,
        totalPages: action.payload.totalPages,
      }
    case CHANGE_BRANCH_REQUESTED:
      return {
        ...state,
        isLoading: true,
        commonError: false,
        errorMessage: false
      }
    case CHANGE_BRANCH_SUCCESS:
      return {
        ...state,
        branches: action.payload.branches,
        loading: false,
        isLoading: false,
        isModal: false,
        isPut: false
      }
    case DELETE_BRANCH_REQUESTED:
      return {
        ...state,
        loading: true,
        commonError: false,
        errorMessage: false
      }
    case DELETE_BRANCH_SUCCESS:
      return {
        ...state,
        branches: action.payload.branches,
        loading: false,
        totalPages: action.payload.totalPages,
      }
    case BRANCH_FAILED:
      const message = typeof action.payload === 'string' ? action.payload : false
      return {
        ...state,
        loading: false,
        errorMessage: message,
        isModal: !!message
      }
    case CHANGE_AD_IMAGE_REQUESTED:
      return {
        ...state,
        commonError: false,
        errorMessage: false
      }
    case CHANGE_AD_IMAGE_SUCCESS:
      return {
        ...state,
        isModal: false,
        isLoading: false,
        commonError: false,
        errorMessage: false
      }
    case GET_AD_IMAGE_REQUESTED:
      return {
        ...state,
        loading: true,
        commonError: false,
        errorMessage: false
      }
    case GET_AD_IMAGE_SUCCESS:
      return {
        ...state,
        advertImage: action.payload.base64Image,
        adImageName: action.payload.name,
        loading: false,
        commonError: false,
        errorMessage: false
      }
    case DELETE_AD_IMAGE_REQUESTED:
      return {
        ...state,
        commonError: false,
        errorMessage: false
      }
    case DELETE_AD_IMAGE_SUCCESS:
      return {
        ...state,
        advertImage: '',
        adImageName: '',
        isLoading:false,
        isModal: false,
      }
    case AD_IMAGE_FAILED:
      const messageAdImage = typeof action.payload === 'string' ? action.payload : false
      return {
        ...state,
        loading: false,
        errorMessage: messageAdImage,
      }
    case RESET_HANDBOOK_ERROR:
      return {
        ...state,
        commonError: null,
      }
    default:
      return state
  }
}

export default branchReducer 
